export const env = {
  siteName: process.env.REACT_APP_SITE_NAME,
  siteLink: process.env.REACT_APP_SITE_LINK,
  apiUrl: process.env.REACT_APP_API_URL,
  tinyMCEAPIKey: process.env.REACT_APP_TINY_MCE_API_KEY,
};